// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for Amazon Route 53 Recovery Cluster (ROUTE53-RECOVERY-CLUSTER)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53recoverycluster.html
 *
 * 2025-02-24T21:49:30.392Z
 */
export enum AwsRoute53RecoveryClusterActions {
  /**
   * Grants permission to get a routing control state
   *
   * See https://docs.aws.amazon.com/routing-control/latest/APIReference/API_GetRoutingControlState.html
   */
  GetRoutingControlState = 'route53-recovery-cluster:GetRoutingControlState',
  /**
   * Grants permission to list routing controls
   *
   * See https://docs.aws.amazon.com/routing-control/latest/APIReference/API_ListRoutingControls.html
   */
  ListRoutingControls = 'route53-recovery-cluster:ListRoutingControls',
  /**
   * Grants permission to update a routing control state
   *
   * See https://docs.aws.amazon.com/routing-control/latest/APIReference/API_UpdateRoutingControlState.html
   */
  UpdateRoutingControlState = 'route53-recovery-cluster:UpdateRoutingControlState',
  /**
   * Grants permission to update a batch of routing control states
   *
   * See https://docs.aws.amazon.com/routing-control/latest/APIReference/API_UpdateRoutingControlStates.html
   */
  UpdateRoutingControlStates = 'route53-recovery-cluster:UpdateRoutingControlStates',
}
